export default __webpack_public_path__ + "static/nodejs-7755913c95b41129ee628e8a23e6ef0c.png";